export default __webpack_public_path__ + "static/media/pictogramPeople48.c3f5aa0a.svg";